import MicroModal from 'micromodal';
import Accordions from './includes/accordions';
import Header from './includes/header';
import SocialShare from './includes/social-share';
import Ads from './includes/ads';
import DateTime from './includes/date-time';
import Hash from './includes/hash';

Hash();
MicroModal.init({
    onShow: (modal, trigger) => {
        trigger.classList.add('is-active');
    },
    onClose: (modal, trigger) => {
        trigger.classList.remove('is-active');
    },
});
Accordions();
Header();
DateTime();
SocialShare();
Ads();
